import React, { Component } from "react";
import Navbar from "./components/Navbar/Navbar";
import "./PersoneroApp.css";
import Candidate from "./components/Candidate/Candidate";
import ModalResults from "./components/ModalResults/ModalResults";
import ModalVote from "./components/ModalVote/ModalVote";
import imgCandidate01 from "./images/img1.png";
import imgCandidate02 from "./images/img2.png";
import imgCandidate03 from "./images/img3.png";
import imgCandidate04 from "./images/img4.png";

class PersoneroApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      candidates: [
        {
          id: 1,
          voteCount: 0,
          name: "Camilo 01",
          img: `${imgCandidate01}`
        },
        {
          id: 2,
          voteCount: 0,
          name: "Andrea 02",
          img: `${imgCandidate02}`
        },
        {
          id: 3,
          voteCount: 0,
          name: "Daniel 03",
          img: `${imgCandidate03}`
        },
        {
          id: 4,
          voteCount: 0,
          name: "Voto en blanco",
          img: `${imgCandidate04}`
        }
      ],
      totalVotes: 0,
      modalResultsIsOpen: false,
      modalVoteIsOpen: false
    };

    this.handleClick.bind(this);
  }

  handleClick = id => {
    this.setState({ modalVoteIsOpen: true });

    let candidatesTmp = this.state.candidates;
    let totalVotes = this.state.totalVotes + 1;
    let element = candidatesTmp.filter(cand => cand.id === id);
    element[0].voteCount = parseInt(element[0].voteCount) + 1;
    this.setState({
      ...this.state.candidates,
      candidatesTmp,
      totalVotes
    });
    console.log(this.state.candidates);
    console.log(this.state.totalVotes);
  };

  handleOpenModalResults = e => {
    this.setState({ modalResultsIsOpen: true });
  };

  handleCloseModalResults = e => {
    this.setState({ modalResultsIsOpen: false });
  };

  handleCloseModalVote = e => {
    this.setState({ modalVoteIsOpen: false });
  };

  render() {
    return (
      <div>

        <Navbar title='Personero App' resultClick={this.handleOpenModalResults} />
        <div className="main__Candidates">
          {this.state.candidates.map(candidate => {
            return (
              <Candidate
                key={candidate.id}
                id={candidate.id}
                name={candidate.name}
                img={candidate.img}
                voteClick={this.handleClick}
              />
            );
          })}
        </div>

        <ModalResults
          isOpen={this.state.modalResultsIsOpen}
          onClose={this.handleCloseModalResults}
          data={this.state}
        />
        <ModalVote
          isOpen={this.state.modalVoteIsOpen}
          onClose={this.handleCloseModalVote}
        />
      </div>
    );
  }
}

export default PersoneroApp;
